import type { MondayTaskElement } from "./schema";
import { BaseElementProvider, ElementProps, ToolbarProps } from "elements/base/provider";
import type { ElementController } from "elements/base/controller";
import React from "react";
import consts, { TypeCanvasElement } from "shared/consts";
import type { BoardContext } from "elements/index";
import MondayTaskController from "./controller";
import MondayTaskElementComponent from "./components/monday-task-component";
import MondayTaskToolbar from "./toolbar/monday-task-toolbar";

export default class MondayTaskElementProvider extends BaseElementProvider<MondayTaskElement> {
  getType(): TypeCanvasElement {
    return consts.CANVAS_ELEMENTS.MONDAY_TASK;
  }

  getElementRenderer(): React.FC<ElementProps<MondayTaskElement>> {
    return MondayTaskElementComponent;
  }

  getToolbarRenderer(): React.FC<ToolbarProps<MondayTaskElement>> {
    return MondayTaskToolbar;
  }

  createController(
    id: string,
    element: MondayTaskElement,
    context: BoardContext,
    _allElementsData: [string, unknown][] = []
  ): ElementController<MondayTaskElement> {
    return new MondayTaskController(id, element, context);
  }

  isConnectorsEnabled(): boolean {
    return true;
  }

  isVotingEnabled(): boolean {
    return true;
  }

  isFFEnabled(): boolean {
    return true;
  }

  isLinkBadgeEnabled(): boolean {
    return false;
  }

  isTableSupported(): boolean {
    return true;
  }
}
